import React from "react";
import axios from "axios";
import "bootstrap/dist/css/bootstrap.min.css";
import { KTMScreen } from "ktm-ui";
import { Spinner } from "react-bootstrap";
import MasterExpenseTypeList from "./Reports/MasterExpenseTypeList";
import AdjudicationMessageCodesList from "./Reports/AdjudicationMessageCodesList";
import DistroSplitsList from "./Reports/DistroSplitsList";
import { List, MessageSquare, Percent } from "lucide-react";

const navItems = [
    { label: "Master Expense Type List", icon: List },
    { label: "Adjudication Message Codes", icon: MessageSquare },
    { label: "Distro Splits", icon: Percent },
];

export default KTMScreen(
    { name: "database" },
    class extends React.Component<any, any> {
        state = {
            currentListItem: "Master Expense Type List",
            loading: true,
            hasAccess: false,
        };

        componentDidMount() {
            axios
                .get("/api/PlanAdmin/getdatabasetabaccess")
                .then((res) => {
                    this.setState({
                        hasAccess: !!(res.data && res.data.hasAccess),
                        loading: false,
                    });
                })
                .catch(() => {
                    this.setState({ hasAccess: false, loading: false });
                });
        }

        setCurrentItem = (item: string) => {
            this.setState({ currentListItem: item });
        };

        render() {
            if (this.state.loading) {
                return (
                    <div className="advisor-page-container">
                        <div style={{ textAlign: "center", padding: 40 }}>
                            <Spinner animation="border" />
                        </div>
                    </div>
                );
            }

            if (!this.state.hasAccess) {
                return (
                    <div className="advisor-page-container">
                        <div className="ktm-reports">
                            <div className="advisor-content-card">
                                <div style={{ padding: 40, textAlign: "center", color: "#555", fontSize: 16 }}>
                                    Database information is for internal use only.
                                </div>
                            </div>
                        </div>
                    </div>
                );
            }

            let contents = null;
            if (this.state.currentListItem === "Master Expense Type List") {
                contents = <MasterExpenseTypeList />;
            } else if (this.state.currentListItem === "Adjudication Message Codes") {
                contents = <AdjudicationMessageCodesList />;
            } else if (this.state.currentListItem === "Distro Splits") {
                contents = <DistroSplitsList />;
            }

            return (
                <div className="advisor-page-container">
                    <div className="ktm-reports">
                        <div className="advisor-nav">
                            {navItems.map((item, index) => (
                                <button
                                    key={index}
                                    className={`advisor-nav-item${
                                        this.state.currentListItem === item.label ? " active" : ""
                                    }`}
                                    onClick={() => this.setCurrentItem(item.label)}
                                >
                                    <item.icon size={18} />
                                    {item.label}
                                </button>
                            ))}
                        </div>
                        <div className="advisor-content-card">
                            <div
                                style={{
                                    background: "#fff8e1",
                                    border: "1px solid #ffe0b2",
                                    color: "#7a4f01",
                                    borderRadius: 4,
                                    padding: "6px 12px",
                                    marginBottom: 12,
                                    fontSize: 13,
                                }}
                            >
                                Database information is for internal use only.
                            </div>
                            {contents}
                        </div>
                    </div>
                </div>
            );
        }
    }
);
